<template>
  <div class="d-flex align-items-center">
    <b-badge
      class="sr-status-badge"
      :class="{'badge-vt-success':params.value, ' badge-vt-pending':!params.value}"
      pill
    >
      {{ text }}
    </b-badge>
  </div>
</template>

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'NotificationRenderer',
    computed: {
        text() {
            return this.params.value ? this.$tc('global.read', 1) : this.$tc('global.unread', 1)
        }
    }
})

</script>
